import { InfoIcon } from '@rsos/assets/icons';
import { InfoBanner } from './TransferToAgencyModal.styles';

interface TransferInfoBannerProps {
  transferType: 'conference' | 'transfer';
  isTransferring?: boolean;
}

function TransferInfoBanner({
  transferType,
  isTransferring,
}: TransferInfoBannerProps) {
  const text =
    transferType === 'conference'
      ? 'You will stay in the chat after you transfer until you choose to leave.'
      : isTransferring
        ? 'Transferring — this can take up to 30 seconds. Please keep this window open.'
        : 'This will immediately transfer the session out of Unite. You will not remain in the chat.';

  return (
    <InfoBanner>
      <InfoIcon width={14} height={14} color="secondaryText" />
      {text}
    </InfoBanner>
  );
}

export default TransferInfoBanner;
